package com.sweetlime.bingeamigo.presentation.features.follow

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.sweetlime.bingeamigo.model.UserProfile
import com.sweetlime.bingeamigo.model.types.FollowType
import com.sweetlime.bingeamigo.presentation.components.FollowUserCard

@Composable
fun FollowListContent(
    type: FollowType,
    onBackClick: () -> Unit,
    openUserProfile: (userId: String) -> Unit,
    profiles: List<UserProfile>,
) {

    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(Color(0xFF121212))
    ) {

        LazyColumn(
            modifier = Modifier.fillMaxSize()
        ) {

            item {
                Spacer(modifier = Modifier.height(120.dp))
                Text(
                    text =
                        if (type == FollowType.FOLLOWERS)
                            "Followers"
                        else
                            "Following",

                    color = Color.White,
                    style = MaterialTheme
                        .typography
                        .headlineMedium,
                    fontWeight = FontWeight.Bold,
                    modifier = Modifier
                        .padding(horizontal = 20.dp)
                )

                Spacer(modifier = Modifier.height(12.dp))
            }

            items(profiles) { user ->
                FollowUserCard(user, openUserProfile)
            }
        }

        // 🔙 Back Button
        IconButton(
            onClick = onBackClick,
            modifier = Modifier
                .statusBarsPadding()
                .padding(start = 20.dp, top = 12.dp)
                .background(
                    Color.Black.copy(alpha = 0.5f),
                    CircleShape
                )
                .align(Alignment.TopStart)
        ) {

            Icon(
                imageVector = Icons.AutoMirrored.Filled.ArrowBack,
                contentDescription = "Back",
                tint = Color.White
            )
        }
    }
}